<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kSOx0B/tc-custom/9781398438668.jpg?1692135036795" alt="This image is the cover for the book The Bean Team at the Circus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Bean Team at the Circus
      </h1>
      <p class="bookDescription body article font2">
        <p>This is the story of six members of the Bean Team going to the circus. The Bean Team girls include Katy Kidney Bean, Yoko Cocoa Bean, Bea Butter Bean. The Bean Team boys are Rory Runner Bean, Hans Baked Bean, Johnny Jumping Bean. <br/>They see the pony gymnasts, Bob and Jayne, showing their riding skills. They see the three clowns, Goldo, Silvo and Bronzo, with their antics. They see the jugglers, ‘The Princelings’ twins David and John Prince, doing juggling tricks. It is afternoon at the circus, the Bean Team have a ‘stripey’ ice cream and popcorn. They see ‘The Flying Angels’ trapeze artists and ‘The Rumbling Tumblers’ performing their acts of balancing. A day filled with fun and adventure. <br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J Brian Jackson, Simon Goodway
      </h2>
      
      <p class="authorDescription body article">J Brian Jackson was born in the North West of England in leafy Cheshire, the eldest of seven siblings. He is married to Val. He has daughters from his first marriage and a son and daughter from his second marriage. Brian, as he is known, has been entrepreneurial all his adult life having been in business since the age of twenty-three with many varied businesses. In 1990, he created The Bean Team characters with the future thought of licensing for retirement. It wasn’t until lockdown in 2020 he started writing children’s Stories featuring The Bean Team characters.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b77c641